var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-accordion", class: _vm.rootClasses }, [
    _vm.$scopedSlots.head
      ? _c(
          "div",
          {
            staticClass: "u-reset ui-accordion--head",
            attrs: {
              role: "heading",
              tabindex: "0",
              "aria-expanded": _vm.state.isOpen ? "true" : "false"
            },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onRequestChange(!_vm.state.isOpen)
              },
              click: function($event) {
                $event.preventDefault()
                return _vm.onRequestChange(!_vm.state.isOpen)
              }
            }
          },
          [_vm._t("head", null, { isOpen: _vm.state.isOpen })],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "body",
        staticClass: "ui-accordion--body",
        attrs: { role: "presentation" },
        on: { transitionend: _vm.onTransitionEnd }
      },
      [
        _vm._t("body", null, {
          isOpen: _vm.state.isOpen,
          isVisible: _vm.isVisible
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6476817a", { render: render, staticRenderFns: staticRenderFns })
  }
}